import React, { useMemo } from 'react';
import { Button, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import classNames from 'classnames';

import { ButtonSplitGroup } from '@components/Buttons';
import { BootstrapGenericTable } from '@components/Table/Table';

const renderActionCell = ({ row, cartProps }) => {
  const { id, canAdd, canRemove } = row.original;
  const { add, remove } = cartProps;

  return (
    <ButtonSplitGroup>
      <Button
        variant="didxl"
        size="sm"
        onClick={() => add.query(id)}
        disabled={!canAdd}
      >
        +
      </Button>
      <Button
        variant="didxl"
        size="sm"
        onClick={() => {
          remove.query(id);
        }}
        disabled={!canRemove}
      >
        -
      </Button>
    </ButtonSplitGroup>
  );
};

const renderChannelsAmountCell = ({ row, value }) => {
  const { current_channel_orders: cartChannels } = row.original;
  const plusSign = cartChannels > 0 ? '+' : null;
  return (
    <>
      {value}{' '}
      {cartChannels ? (
        <span
          className={classNames({
            textGreen: cartChannels > 0,
            textRed: cartChannels < 0,
          })}
        >
          {' '}
          ({plusSign}
          {cartChannels})
        </span>
      ) : null}
    </>
  );
};

const renderActionHeader = ({ cartProps }) => (
  <>
    <p className="m-0">Action</p>
    <Button onClick={() => cartProps.clear.query()} variant="didxl" size="sm">
      Clear
    </Button>
  </>
);

export const SharedChannelsTable = ({ useData, cartProps }) => {
  const [searchParams, _] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useSelector((state) => state.auth.user);
  const exportContent = () => (
    <ButtonSplitGroup>
      <Button
        variant="didxl"
        size="sm"
        onClick={() => {
          navigate('/cart/checkout');
        }}
      >
        Buy and Check-out
      </Button>
      <Button
        as={Link}
        variant="didxl"
        size="sm"
        to="/order/shared-channels/cancel"
      >
        Cancel channels
      </Button>
    </ButtonSplitGroup>
  );
  const country = searchParams.get('country');
  const plan = searchParams.get('plan');
  const planType = searchParams.get('type');
  const filterData = {
    country,
    plan,
    type: planType,
  };

  const columns = useMemo(
    () => [
      {
        id: 'id',
        accessor: 'id',
      },
      {
        id: 'name',
        Header: 'DID-Group',
        accessor: 'name',
        className: 'col-md-2',
      },
      {
        id: 'country',
        Header: 'Country',
        accessor: 'country',
      },
      {
        id: 'nrc',
        Header: 'NRC',
        accessor: 'nrc',
        className: 'col-md-1',
      },
      {
        id: 'mrc',
        Header: 'MRC',
        accessor: 'mrc',
        className: 'col-md-1',
      },
      {
        Header: 'Total Channels',
        accessor: 'channel_amount',
        className: 'col-md-1',
        Cell: ({ row, value }) =>
          renderChannelsAmountCell({ row, value, cartProps }),
      },
      {
        Header: 'Max Channels',
        accessor: 'max_channel_amount',
        className: 'col-md-1',
      },
      {
        Header: () => renderActionHeader({ cartProps }),
        Cell: ({ row }) =>
          renderActionCell({
            row,
            cartProps,
          }),
        accessor: 'action',
        className: 'col-md-1 text-center',
      },
    ],
    [country, plan]
  );
  return (
    <Card>
      <Card.Header className="bg-didxl text-white">
        Order shared channels for DID-Groups
      </Card.Header>
      <Card.Body>
        <BootstrapGenericTable
          useData={useData}
          columns={columns}
          filterData={filterData}
          tableProps={() => ({
            responsive: true,
            bordered: true,
            className: 'normalFontSize',
          })}
          paginated
          useDataArgs={{ login }}
          exportContent={(table) => exportContent(table)}
          hiddenColumns={['id', 'country']}
        />
      </Card.Body>
    </Card>
  );
};
